import React, { useContext, useEffect, useState } from "react";
import "../../../../CapsitechAccountsComponents/Pages/Assets/Css/Assets.css";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Row,
  Button,
  Input,
  Table,
  Tooltip,
  Col,
  Card,
  Select,
  Skeleton,
} from "antd";
import { ColumnsType } from "antd/es/table";
import FixedAssetsService, {
  AssetStatus_New,
  FAAdjust_Type,
  IChildAssetsListResponse,
  IFAListResponse,
} from "../../../Services/FixedAssetsServiceNew";
import { useClient } from "../../../Context/ClientContext";
import { useTheme } from "../../../Context/ThemeContext";
import search from "../../../Images/search.svg";
import { Utils } from "../../../../Utilities/Utils";
import ViewAssetModel from "../ViewAssetModel";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import AssetJournalModal from "../AssetJournalModal";
import { useLocation, useNavigate } from "react-router-dom";
import { dayjs } from "../../../../Utilities/dayjs";
import { findUserPremission } from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";
import { SettingsSections } from "../../../Services/SettingService";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import AddAsset from "./AddAssetItems";
import AddAssetItems from "./AddAssetItems";
import { ItemAdd_Type } from "../../../Services/ItemsService";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import FixedAssetsServiceNew from "../../../Services/FixedAssetsServiceNew";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

const AssetChildItemsTable = ({
  setFixedAssetListPassToOpeningBalance,
  // setOpenAssetModal,
  assetPurchaseType,
  addAssetTrigger,
}: {
  setFixedAssetListPassToOpeningBalance?: React.Dispatch<
    React.SetStateAction<any[]>
  >;
  addAssetTrigger?: boolean;
  assetPurchaseType?: boolean;
}) => {
  const { clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const { themeData } = useTheme();
  const { currentClient, companySettings } = useClient();
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const [successRollBack, setSeccesRollBack] = React.useState<boolean>(false);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [faChildList, setFAChildList] = React.useState<
    IChildAssetsListResponse[]
  >([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [searchAsset, setSearchAsset] = React.useState("");
  const [isViewModelOpen, setIsViewModelOpen] = useState<boolean>(false);
  const [assetId, setAssetId] = React.useState<{
    assetId: string;
    childAssetName: string;
  }>({
    assetId: "",
    childAssetName: "",
  });
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [type, setType] = React?.useState<boolean>(Boolean);

  const [changeStatus, setChangeStatus] = React.useState<number>(
    AssetStatus_New.Active
  );

  const [deleteOrRevive, setDeleteOrRevive] = React.useState<any>({
    id: "",
    isRev: null,
  });

  const [assetModelOpen, setAssetModelOpen] = React.useState<{
    open: boolean;
    param: string;
    openingAsset: boolean;
  }>({ open: false, param: "", openingAsset: false });

  const [refreshAtDelete, setRefreshAtDelete] = React.useState<boolean>(false);

  //for getlist
  useEffect(() => {
    setLoading(true);
    getList(
      currentClient?.id!,
      (page - 1) * pageSize,
      pageSize,
      undefined,
      undefined,
      searchAsset,
      changeStatus,
      assetPurchaseType ? ItemAdd_Type.Opening : ItemAdd_Type.All
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    trigger,
    page,
    pageSize,
    searchAsset,
    changeStatus,
    refreshAtDelete,
    // successRollBack,
    addAssetTrigger,
  ]);

  // Api Asset Items Get List
  const getList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol: any,
    sortDir: any,
    search: string,
    status: AssetStatus_New,
    type: ItemAdd_Type
  ) => {
    await FixedAssetsServiceNew.getChildAssetsList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      type
    )
      .then(({ result }) => {
        if (result?.items?.length > 0) {
          setFAChildList(
            result?.items?.map((e, index: number) => {
              return {
                ...e,
                sno: index + 1,
                key: index + 1,
              };
            }) || []
          );
          setTotalRecords(result?.totalRecords);
          setFixedAssetListPassToOpeningBalance &&
            setFixedAssetListPassToOpeningBalance(result?.items);
        } else if (result.items.length === 0) {
          setFAChildList([]);
          setTotalRecords(result?.totalRecords);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    setLoading(false);
  };

  // // ----- Short-Cut for Open Model -----F
  // useKeyboardShortcuts("N", ["shiftKey"], () => {
  //   setIsModalOpen(true);
  // });

  const permissionEdit = findUserPremission(
    ["Voucher.Asset.11.Edit"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Edit,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  const permissionDelete = findUserPremission(
    ["Voucher.Asset.11.Delete"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Delete,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  // Table columns
  const columns: ColumnsType<IChildAssetsListResponse> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Asset Name",
      dataIndex: "assetRef",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val?.name}
        </Skeleton>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {dayjs(val).format("DD-MM-YYYY")}
        </Skeleton>
      ),
    },
    {
      title: "Available Qty",
      dataIndex: "availableQty",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },
    {
      title: "Purchase Price",
      dataIndex: "price",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {Utils.getFormattedNumber(val)}
        </Skeleton>
      ),
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      width: "8%",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },
    {
      title: "Location",
      dataIndex: "locationName",
      width: "8%",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },
    {
      title: "Employee",
      dataIndex: "empName",
      width: "8%",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },
    {
      title: "Depreciable Asset",
      dataIndex: "isDepreciable",
      align: "center",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          {val ? "Yes" : "No"}
        </Skeleton>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          <>
            {permissionEdit ? (
              record.status !== AssetStatus_New.Disposed ? (
                <Tooltip title="Edit" color="#444653" placement="top">
                  <EditOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setAssetModelOpen({
                        open: true,
                        param: record.assetRef?.id,
                        openingAsset:
                          record?.adjust === FAAdjust_Type.OpeningStock
                            ? true
                            : false,
                      });
                    }}
                  />
                </Tooltip>
              ) : (
                ""
              )
            ) : (
              <></>
            )}
          </>
        </Skeleton>
      ),
    },
  ];

  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          marginTop: 5,
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        <Row
          justify={"space-between"}
          style={{
            padding: "0px 0px 3px 0px",
          }}
        >
          {findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) && (
            <Col>
              <Row>
                {!assetPurchaseType && (
                  <Col>
                    <Button
                      type="primary"
                      onClick={() =>
                        setAssetModelOpen({
                          open: true,
                          param: "",
                          openingAsset: false,
                        })
                      }
                    >
                      <PlusOutlined />
                      Asset Item
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          )}

          <Col>
            <Row gutter={10}>
              <Col>
                <Input
                  style={{ width: "200px" }}
                  placeholder="Search asset"
                  allowClear
                  onChange={(e: any) => {
                    setPage(1);
                    setSearchAsset(e.target.value);
                    //console.log(e.target.value, "search");
                  }}
                  suffix={
                    loading || searchAsset ? (
                      ""
                    ) : (
                      <img alt="search" src={search} />
                    )
                  }
                />
              </Col>

              <Col style={{ justifyContent: "end", gap: 10 }}>
                <Select
                  defaultValue={AssetStatus_New.Active}
                  style={{ width: 120 }}
                  options={[
                    { value: AssetStatus_New.All, label: "All", title: "" },
                    {
                      value: AssetStatus_New.Active,
                      label: "Active",
                      title: "",
                    },
                    {
                      value: AssetStatus_New.Disposed,
                      label: "Disposed",
                      title: "",
                    },
                  ]}
                  onChange={(e: any) => {
                    setChangeStatus(e);
                    console.log(e, "changestatusassets");
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Table
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          columns={columns}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IChildAssetsListResponse[])
              : faChildList
          }
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
            pageSizeOptions: tablePageSizeOptions,
          }}
          // scroll={
          //   pageSize > 15 ? { x: 1300, y: window.innerHeight - 300 } : undefined
          // }
        />
      </Card>
      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            setDeleteOrRevive({
              id: assetId,
              isRev: changeStatus === AssetStatus_New.Disposed ? true : false,
            });
            //console.log("yogesh");
            setConfirmation(false);
          }}
          text={
            changeStatus === AssetStatus_New.Disposed
              ? `Are you sure you want to revive ?`
              : `Are you sure you want to Delete this row ?`
          }
        />
      )}
      {assetModelOpen.open && (
        <AddAssetItems
          open={assetModelOpen.open}
          onCancel={() =>
            setAssetModelOpen({ open: false, param: "", openingAsset: false })
          }
          oldPurchaseType={assetModelOpen.openingAsset!}
          setAssetModelOpen={setAssetModelOpen}
          setTrigger={setTrigger}
          editAssetId={assetModelOpen.param}
        />
      )}
      {/* {isViewModelOpen && (
        <ViewAssetModel
          isViewModelOpen={isViewModelOpen}
          onCancel={() => setIsViewModelOpen(false)}
          assetId={assetId}
          type={type}
        />
      )} */}
    </>
  );
};
export default AssetChildItemsTable;
